<template>
  <div class="interview-sheet renew2_wrapper">
    <h3>面接用質問一覧</h3>

    <div v-if="isLoading" class="loading-container" ref="addQuestionButton">
      <div class="loading-spinner"></div>
      <p>質問を取得中...</p>
    </div>
    
    <ul v-else>
      <li v-for="(question, index) in questions" :key="index" class="question-item">
        <span class="question-text">{{ question }}</span>
      </li>
    </ul>

    <div v-if="!isLoading" class="add-question">
      <button @click="addMoreQuestion(newQuestion)">質問生成</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InterviewSheet',
  props: {
    companyInfo: {
      type: String,
      required: true
    },
    motivation: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      questions: [],
      newQuestion: '',
      isLoading: true
    };
  },
  async created() {
    try {
      const response = await this.$axios.post(this.$varuna.endPoints.aiInterviewSheet, {
        uuid: this.$firebase.user.uid,
        companyInfo: this.companyInfo,
        reason: this.motivation,
      });
      for (let i = 0; i < response.data.questions.length; i++) {
        this.questions.push(response.data.questions[i].question);
      }
    } catch (error) {
      console.error('Error fetching interview sheet:', error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    addQuestion(newQuestion) {
      if (!newQuestion) return;
      this.questions.push(newQuestion);
      this.newQuestion = '';
    },
    async addMoreQuestion() {
      this.isLoading = true;
        this.scrollToButton();
      try {
        const response = await this.$axios.post(this.$varuna.endPoints.addQuestion, {
          uuid: this.$firebase.user.uid,
          companyInfo: this.companyInfo,
          reason: this.motivation,
        });
        const more_question = await response.data.questions;
        console.log(more_question);
        this.questions = [];
        for (let i = 0; i < more_question.length; i++) {
          this.questions.push(more_question[i].question);
        }
      } catch (error) {
        console.error('Error adding more questions:', error);
      } finally {
        this.isLoading = false;
      }
    },
    scrollToButton() {
      this.$nextTick(() => {
        this.$refs.addQuestionButton.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }
};
</script>

<style scoped>
.loading-container {
  text-align: center;
  margin-top: 20px;
}
.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.question-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
  flex-wrap: nowrap;
}
.remove-button {
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  white-space: nowrap;
}
.remove-button:hover {
  background-color: #c0392b;
}
.add-question {
  display: flex;
  margin-top: 20px;
}
.add-question input {
  flex: 1;
  padding: 8px;
  margin-right: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.add-question button {
  padding: 8px 16px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.add-question button:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}
.add-question button:hover:not(:disabled) {
  background-color: #2980b9;
}
</style>